import React from 'react';
import "./css/style.css";

const SegundaTitulacion = () => {
  const handleSolicitud = () => {
    window.open('https://utpl.edu.ec/zoom', '_blank');
  };

  return (
    <div className="card-container margin">
      <header className="card-header">
        <h2>Segunda titulación</h2>
        <p className="subtitle">
          Eleva tu perfil profesional, accede a una <strong>segunda carrera o posgrado</strong> de manera simultánea en la UTPL y benefíciate de un <strong>20% de descuento</strong> exclusivo.
        </p>
      </header>

      <section className="card-body layout9">
        <div className="alert-box">
          <p>
            Recuerda que para acceder a este descuento debes estar inscrito previamente en una carrera de grado o posgrado (el descuento no aplica para carreras tecnológicas).
          </p>
          <p className="instruction-text">
            Para solicitar el descuento primero debes registrar un servicio en nuestra plataforma institucional.
          </p>
        </div>

        <button className="btn-primary" target="_blank" onClick={() => window.location.href = 'https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService'}>
          Solicita ahora
        </button>

        <div className="process-section">
          <h3>Proceso de solicitud:</h3>
          <ol className="process-list">
            <li>Haz clic en <strong>Solicita ahora</strong> e ingresa con tus credenciales institucionales.</li>
            <li>Dirígete a <strong>Solicitud de Servicios</strong>, selecciona <strong>Servicios-Matrícula</strong> y elige la opción: <strong>Solicitar segunda carrera</strong>.</li>
            <li>Selecciona tu carrera y en detalle de requerimiento escribe la carrera a la cual deseas aplicar. <em>Ejemplo: “solicito cursar simultáneamente la carrera de…”</em></li>
            <li>Recuerda que para seguir dos carreras en la misma modalidad (presencial o en línea) debes solicitar previamente la autorización de tu director.</li>
          </ol>
        </div>

        <div className="info-grid">
          <div className="info-item">
            <span className="label">Costo del servicio:</span>
            <span className="value">Gratuito</span>
          </div>
         
        </div>

        <p className="status-note">
          Consulta el estado de la solicitud en el sistema institucional, apartado <strong>Ver status de la solicitud de servicio</strong>.
        </p>
      </section>

      <footer className="card-footer">
        <h4>¿Necesitas más información?</h4>
        <p>Solicita asesoría virtual en:</p>
        <div className="contact-links">
          <a href="https://utpl.edu.ec/zoom" target="_blank" rel="noreferrer">utpl.edu.ec/zoom</a>
          <a href="https://wa.me/593999565400" target="_blank" rel="noreferrer">WhatsApp: 0999565400</a>
        </div>
      </footer>
    </div>
  );
};

export default SegundaTitulacion;